import axios, {AxiosResponse} from 'axios'
import {FranchiseInvoiceChargesQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const FRANCHISEINVOICE_URL = `${API_URL}/franchises`

const getFranchiseInvoiceCharges = (
  query: string,
  franchiseId: number,
  invoiceId?: number,
  invoiceItemId?: number
): Promise<FranchiseInvoiceChargesQueryResponse> => {
  const params = new URLSearchParams(query)
  if (invoiceItemId !== undefined) {
    params.set('invoice_item_id', String(invoiceItemId))
  }
  const cleanQuery = params.toString() ? `?${params.toString()}` : ''

  const invoicePath = invoiceId !== undefined ? invoiceId : 'current'
  const url = `${FRANCHISEINVOICE_URL}/${franchiseId}/invoices/${invoicePath}/charges${cleanQuery}`

  return axios.get(url).then((d: AxiosResponse<FranchiseInvoiceChargesQueryResponse>) => d.data)
}

const downloadServerFile = async (
  filter: string | undefined,
  franchiseId: number,
  invoiceId?: number
): Promise<{message: string; id: number} | void> => {
  var filterAdjust = filter !== undefined ? `?${filter}` : ''
  try {
    const invoicePath = invoiceId !== undefined ? invoiceId : 'current'
    const url = `${FRANCHISEINVOICE_URL}/${franchiseId}/invoices/${invoicePath}/charges/export${filterAdjust}`

    const response = await axios({
      url: url,
      method: 'GET',
      responseType: 'blob',
    })

    const contentType = response.headers['content-type'] ?? ''

    if (contentType.includes('application/json')) {
      const text = await (response.data as Blob).text()
      return JSON.parse(text) as {message: string; id: number}
    }

    const href = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', 'invoice-charges.xlsx')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  } catch (_) {}
}

export {getFranchiseInvoiceCharges, downloadServerFile}